import styles from './Divider.module.scss';

const Divider: React.FC<{ thick?: boolean, noMargin?: boolean }> = ({ thick = false, noMargin = false }) => {
    return <hr className={`${styles.divider} ${thick ? styles.thick : ''} ${noMargin ? styles.noMargin : ''}`} />;
};

export default Divider;